import decodePath from './decodePath';

function processOsrmData(response) {
  const data = response.data || response;
  if (data.message) {
    throw new Error(data.message);
  }
  const dirRoute = data.routes[0];
  const path = decodePath(dirRoute.geometry, 5);
  let offset = 0;
  const paths = dirRoute.legs.map(leg => {
    const len = leg.annotation.distance.length;
    const legPath = path.slice(offset, offset + len + 1);
    offset += len;
    return legPath;
  });
  return paths;
}

export default processOsrmData;
